const subTabs = {
    login: [{path: "login"}],
    //Roles hidden temporarily while the rol is sent by email; its route (/roles) still works. Restore: add back {label: "Roles", path: "roles"}
    produccion: [{label: "Dashboard", path:"dashboard"}, {label: "Proceso", path:"proceso"}, {label: "Jobtrack", path: "jobtrack"}, {label: "Historial de planta", path: "historialplanta"}, {label: "Reportes de planta", path: "reportesplanta"}],
    ventas: [{label: "Forecast", path: "forecast"}, {label: "Presupuesto", path: "presupuesto"}],
    compras: [{label: "Necesidad de compra", path: "necesidadcompra"}],
    recursoshumanos: [{label: "Recursos Humanos", path: "rh"}, {label: "Nómina", path: "nominas"}],
    administracion: [{label: "Acceso", path: "acceso"}],
}
export default subTabs;